module.exports = __webpack_public_path__ + "static/media/ema-chocholacova-cv.08be9d01.pdf";